import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'

import { Wrapper, DynamicImageStyled, Shadow, IconWrapper } from './styles'

const BAboutFirstBlockEuroBox = ({ path }) => {
  return (
    <Wrapper>
      <DynamicImageStyled
        image={`${path}/biome-flying-v1`}
        imageSizes={{ xs: 320, md: 500 }}
        imageType="png"
        fitOption={'contain'}
        alt={'Microbiome Box'}
      />

      <Shadow image={`${path}/box-shadow`} />

      <IconWrapper isFirstGuy={true}>
        <Icon id="color_guy1" />
      </IconWrapper>

      <IconWrapper isFirstGuy={false}>
        <Icon id="color_guy2" />
      </IconWrapper>
    </Wrapper>
  )
}

BAboutFirstBlockEuroBox.propTypes = {
  path: PropTypes.string.isRequired,
}

export default BAboutFirstBlockEuroBox
